export default __webpack_public_path__ + "static/media/Princ Xion.2dcf1cd7.png";